export default from './accessibility-listener';



// WEBPACK FOOTER //
// ./app/components/accessibility-listener/index.js